export default "__VITE_ASSET__BD1wVZ4___"